import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicTcnMaryland from "../Components/ProjPicTCNMaryland";

const ProjectPageTcnMaryland = () => {
    return (
        <>
            <Navbar />
            <ProjPicTcnMaryland />
            <Footer />
        </>
    );
};

export default ProjectPageTcnMaryland;
